import React from "react";

const Pets = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M12.4004 14C13.2004 14 13.4004 13.3333 13.4004 13H11.4004C11.4004 13.3333 11.6004 14 12.4004 14ZM12.4004 14V15M12.4004 15C12.4004 15.6667 12.8004 17 14.4004 17C16.0004 17 16.4004 15.6667 16.4004 15M12.4004 15C12.4004 15.6667 12.0004 17 10.4004 17C8.80039 17 8.40039 15.6667 8.40039 15M15.4004 10V10.01M9.40039 10V10.01M4.40039 3V13C4.40039 15.6667 6.00039 21 12.4004 21C18.8004 21 20.4004 15.6667 20.4004 13V3L16.9004 6.5L14.9302 5.84327C13.2881 5.2959 11.5127 5.2959 9.87057 5.84327L7.90039 6.5L4.40039 3Z"
        stroke="#00A3BC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Pets;
